import { STATUS_TYPES, LABELS } from './AffectedProductsTab.constants';
import { getImpactStatusConfig } from '@Utils/impactStatus';

const ICON_BY_STATUS_TYPE = {
    [STATUS_TYPES.IMPACTED]: 'DoDisturbIcon',
    [STATUS_TYPES.NOT_IMPACTED]: 'CheckCircleIcon',
    [STATUS_TYPES.TO_BE_DETERMINED]: 'HelpOutlineIcon'
};

/**
 * Gets status configuration based on impact status.
 * Label and color come from the shared impactStatus util (single source of truth);
 * the icon string is mapped locally from the status type.
 * @param {boolean|null|undefined} isImpacted - Whether product is impacted (null/undefined = TBD)
 * @returns {Object} - Status configuration with { type, label, color, icon }
 */
export const getStatusConfig = (isImpacted) => {
    const shared = getImpactStatusConfig(isImpacted);
    return {
        type: shared.key,
        label: shared.label,
        color: shared.color,
        icon: ICON_BY_STATUS_TYPE[shared.key]
    };
};

/**
 * Filters products based on brand and country
 * @param {Array} products - Array of products
 * @param {boolean} readOnly - Whether in read-only mode
 * @param {string} brandFilter - Brand filter text
 * @param {string} countryFilter - Country filter value
 * @returns {Array} - Filtered products
 */
export const filterProducts = (products, readOnly, brandFilter = '', countryFilter = '') => {
    if (readOnly) return products;
    let result = products;
    if (brandFilter) {
        const lowerBrand = brandFilter.toLowerCase();
        result = result.filter(p => (p.brand || '').toLowerCase().includes(lowerBrand));
    }
    if (countryFilter) {
        result = result.filter(p =>
            (p.countries || []).some(c => (c.name || c) === countryFilter)
        );
    }
    return result;
};

/**
 * Determines if a product checkbox should be disabled
 * @param {boolean} readOnly - Read-only mode
 * @param {boolean} isPlanned - Whether product is already planned
 * @returns {boolean} - Disabled state
 */
export const isProductDisabled = (readOnly, isPlanned) => {
    return readOnly || isPlanned;
};

/**
 * Gets the appropriate empty message
 * @param {number} totalProducts - Total products count
 * @param {number} plannedCount - Planned products count
 * @returns {string} - Empty message
 */
export const getEmptyMessage = (totalProducts, plannedCount) => {
    if (totalProducts === 0 && plannedCount > 0) {
        return LABELS.ALL_PRODUCTS_PLANNED;
    }
    return LABELS.NO_PRODUCTS;
};